import * as createProductRelated from 'store/actions/products/related/createProductRelated';
import * as deleteProductRelated from 'store/actions/products/related/deleteProductRelated';
import * as fetchProductRelated from 'store/actions/products/related/fetchProductRelated';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* fetchOneProductRelatedAsync({ payload }) {
    const { productId } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/related-products?product_id[]=${ productId }`;

        const response = yield apiClient.read(url);

        yield put(fetchProductRelated.fetchProductRelatedSuccess(response, productId));
    } catch (error) {
        yield put(fetchProductRelated.fetchProductRelatedFailure(error, productId));
    }
}

function* createProductRelatedAsync({ payload }) {
    try {
        const { productId, productRelatedId } = payload;

        const params = {
            'product_id': productId,
            'related_product_id': productRelatedId,
        };

        const url = `${ config.getApiBaseUrl() }/related-products`;

        const response = yield apiClient.create(url, params);

        yield put(createProductRelated.createProductRelatedSuccess(response));
    } catch (error) {
        yield put(createProductRelated.createProductRelatedFailure(error));
    }
}

function* createProductRelatedSuccessAsync() {
    yield put(showNotification('notifications.products.related.create.success'));
}

function* deleteProductRelatedAsync({ payload }) {
    try {
        const { productId, productRelatedId, relatedId } = payload;

        const url = `${ config.getApiBaseUrl() }/related-products/${ relatedId }`;

        yield apiClient.delete(url);

        yield put(deleteProductRelated.deleteProductRelatedSuccess(productId, productRelatedId));
    } catch (error) {
        yield put(deleteProductRelated.deleteProductRelatedFailure(error));
    }
}

function* deleteProductRelatedSuccessAsync() {
    yield put(showNotification('notifications.products.related.delete.success'));
}

function* failureMessage({ error }) {
    yield put(showNotification(error.response.message, 'warning'));
}

export default function* productRelatedSagas() {
    yield [
        takeEvery(types.FETCH_ONE_PRODUCT_RELATED, fetchOneProductRelatedAsync),
        takeEvery(types.FETCH_ONE_PRODUCT_RELATED_FAILURE, failureMessage),

        takeEvery(types.CREATE_PRODUCT_RELATED, createProductRelatedAsync),
        takeEvery(types.CREATE_PRODUCT_RELATED_FAILURE, failureMessage),
        takeEvery(types.CREATE_PRODUCT_RELATED_SUCCESS, createProductRelatedSuccessAsync),

        takeEvery(types.DELETE_PRODUCT_RELATED, deleteProductRelatedAsync),
        takeEvery(types.DELETE_PRODUCT_RELATED_FAILURE, failureMessage),
        takeLatest(types.DELETE_PRODUCT_RELATED_SUCCESS, deleteProductRelatedSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/productRelatedSagas.js